<template>
<div :id="uid" :style="{height: `${height}px`, width: `${width}px`}" class="cards-pile">
    <div style="position: relative; height: 100%; width: 100%">
        <div class="pile-marker" :style="{backgroundImage: 'url(' + require('@/assets/pile-position.png') + ')'}"></div>
        <div ref="dropZone" :style="{position: 'absolute', height: '100%', width: '100%'}"></div>
        <div ref="counter" class="pile-counter"><span>{{cards.length}}</span></div>
        <div class="pile-actions pile-draggable" ref="dragPile" :style="{flexDirection: inverted ? 'row-reverse' : 'row'}">
            <button class="btn-action" v-if="showShuffle && cards.length > 1" @click="Shuffle">↺</button>
            <button class="btn-action" v-if="hidden && cards.length" @click="TogglePileVisibility">{{showPile ? 'Ø' : 'O'}}</button>    
            <button class="btn-action" v-if="cards.length > 1" @click="ToggleList">{{list ? (inverted ? '⟶' : '⟵') : (inverted ? '⟵' : '⟶')}}</button>
        </div>
    </div>
    <div ref="counter2" v-show="dragPosition" class="pile-counter-drag" :style="{left: `${dragPosition ? dragPosition.x : 0}%`, top: `${dragPosition ? dragPosition.y : 0}%`, width: `${width}px`, height: `${height}px`}"><span>{{cards.length}}</span></div>
</div>
</template>

<script>
import interact from 'interactjs'
export default {
    props: {
        uid: {type: String, default: ''},
        height: {type: Number, default: 0},
        width: {type: Number, default: 0},
        hidden: {type: Boolean, default: false},
        inverted: {type: Boolean, default: false},
        showShuffle: {type: Boolean, default: false},
        downTarget: {type: String, default: null},
        upTarget: {type: String, default: null},
        leftTarget: {type: String, default: null},
        rightTarget: {type: String, default: null},
    },
    data() {
        return {
            z: 0,
            x: 0,
            y: 0,
            cards: [],
            list: false,
            showPile: false,
            dragPosition: null,
            interactDrag: null,
        }
    },
    mounted() {
        
        this.$el.parentNode.appendChild(this.$refs.counter2);

        let t = this;
        interact(this.$refs.dropZone).dropzone({
            ondrop: this.OnDrop,
            ondragenter: function(e) {
                t.OnDragEnter(e);
            },
            ondragleave: function(e) {
                t.OnDragLeave(e);
            },
            ondropmove: function(e) {
                t.OnDragEnter(e);
            },
        });

        this.interactDrag = interact(this.$refs.dragPile).draggable({
            listeners: {
                start(e) {
                    t.OnStartDrag(e);
                },
                move(e) {
                    t.OnDrag(e);
                },
                end(e) {
                    t.OnEndDrag(e);
                }
            }
        })

    },
    beforeDestroy() {

    },
    methods: {
        Reset() {
            this.cards = [];
            this.showPile = false;
            this.list = false;
            this.Update();
        },
        OnDrop(e) {

            let card = e.relatedTarget;
            if(!e.autoIndex) this.DragOver(card, false);
            if(card && card.__vue__)
            {
                let index = null;
                if(e.autoIndex === true) index = this.cards.length;
                if(this.list && index === null) {
                    let rect = card.getBoundingClientRect();
                    let i = 0;
                    for(i = 0; i < this.cards.length; i++)
                    {
                        let listRect = this.cards[i].$el.getBoundingClientRect();
                        if(listRect.x > rect.x)
                        {
                            index = i;
                            break;
                        }

                    }
                }

                this.AttachCard(card.__vue__, index);
                this.$socket.client.emit('AttachCard', {parent: this.uid, card: card.__vue__.uid, index: index});
            }

            //drag pile to pile
            if(card.classList.contains('pile-draggable'))
            {
                let pile = card.parentNode.parentNode.__vue__;
                if(pile == this) return;
                this.AttachPile(pile);
                this.$socket.client.emit('AttachPile', {target: this.uid, pile: pile.uid});
            }
        },
        OnDragEnter(e) {
            this.DragOver(e.relatedTarget, true);
        },
        OnDragLeave(e) {
            this.DragOver(e.relatedTarget, false);
        },
        OnStartDrag(e) {
            //this.cards[this.cards.length-1].OnStartDrag(e);
        },
        OnDrag(e) {
            //this.cards[this.cards.length-1].OnDrag(e);
            let rectArena = document.getElementById('arena').getBoundingClientRect();
            let x = ((e.client.x - rectArena.x) / rectArena.width) * 100;
            let y = ((e.client.y - rectArena.y) / rectArena.height) * 100;
            this.Move(x, y);
            this.$socket.client.emit('MovePile', {id: this.uid, position: this.dragPosition});
        },
        OnEndDrag(e) {
            this.dragPosition = null;
            this.$socket.client.emit('MovePile', {id: this.uid, position: this.dragPosition});
        },
        Move(x, y, mirrored) {
            this.x = mirrored ? 100-x-cardWidthPercentage : x;
            this.y = mirrored ? 100-y-cardHeightPercentage : y;
            this.dragPosition = {x: x, y: y};
        },
        AttachCard(card, index)
        {
            let arrCards = Array.isArray(card) ? card : [card];
            if(!Array.isArray(card))
            {
                arrCards = arrCards.concat(card.childs);
                card.childs = [];
            }

            if(typeof index == 'number') {
                arrCards.forEach(c => {
                    this.cards.splice(index, 0, c);
                    c.SetParent(this);
                });
            }
            else
            {
                if(!Array.isArray(card)) arrCards.reverse();
                arrCards.forEach(c => {
                    this.cards.push(c);
                    c.SetParent(this);
                });
            }

            this.Update();
        },
        DeattachCard(card) {
            for(let i = 0; i < this.cards.length; i++)
            {
                if(card == this.cards[i])
                {
                    this.cards.splice(i, 1);
                    break;
                }
            }
            card.parent = null;
            this.Update();
        },
        AttachPile(pile)
        {
            
            this.AttachCard(pile.cards);
            pile.cards = [];
            pile.Update();
            this.Update();
        },
        Update()
        {
            let rectArena = document.getElementById('arena').getBoundingClientRect();
            let rect = this.$el.getBoundingClientRect(); 
            this.x = ((rect.x - rectArena.x) / rectArena.width) * 100;
            this.y = ((rect.y - rectArena.y) / rectArena.height) * 100;
            
            for(let i = 0; i < this.cards.length; i++)
            {
                let placementIndex = this.inverted ? this.cards.length-i-1 : i;
                let offsetX = this.list ? (this.width * 0.3 * (this.inverted ? -1 : 1)) * placementIndex : 0;
                this.cards[i].Move(this.x, this.y, offsetX);
                this.cards[i].z = this.list ? 2000 + (placementIndex * (this.inverted ? -1 : 1)) : 10 + i;
                this.cards[i].hidden = this.hidden && !this.showPile;
                
                this.cards[i].$el.classList.remove('no-transition');
            }   
        },
        ToggleList() {
            this.list = !this.list;
            this.interactDrag.draggable(!this.list);
            this.Update();
        },
        Resize() {
            this.x = (this.$el.getBoundingClientRect().x / document.getElementById('arena').getBoundingClientRect().width) * 100;
            this.y = (this.$el.getBoundingClientRect().y / document.getElementById('arena').getBoundingClientRect().height) * 100;
            this.Update();
        },
        TogglePileVisibility() {
            this.showPile = !this.showPile;
            this.Update();
            this.$socket.client.emit('ShowPile', {id: this.uid, show: this.showPile});
        },
        Shuffle()
        {
            if(!this.showShuffle) return;
            let tmp = this.cards.map(value => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value);
            
            let order = [];
            tmp.forEach(card => {
                order.push(card.uid);
            });
            this.ShuffleByIds(order);
            this.$socket.client.emit('ShufflePile', {id: this.uid, order: order});

        },
        ShuffleByIds(uids)
        {
            let ordered = [];
            uids.forEach(uid => {
                let c = this.cards.find(card => {
                    return card.uid == uid;
                });
                ordered.push(c);
            });
            this.cards = ordered;
            this.Update();
            this.$refs.counter.classList.remove('pile-shake');
            setTimeout(() => {
                this.$refs.counter.classList.add('pile-shake');
            }, 10);
            return;
        },
        DragOver(card, entered)
        {
            if(entered) this.$el.classList.add('targeted');
            else this.$el.classList.remove('targeted');

            if(card.classList.contains('cards-pile') && this.list) return;

            if(this.list)
            {
                let rect = card.getBoundingClientRect();
                for(let i = 0; i < this.cards.length; i++)
                {
                    let listRect = this.cards[i].$el.getBoundingClientRect();
                    if(listRect.x < rect.x)
                    {
                        //this.cards[i].$refs.imgContainer.style.transform = entered ? `translateX(${this.width * -1}px)` : "";
                        this.cards[i].$refs.imgContainer.style.transform = "";
                    }
                    else
                    {
                        this.cards[i].$refs.imgContainer.style.transform = entered ? `translateX(${this.width * 1.2}px)` : "";
                    }

                }
            }
        }
    }
}
</script>

<style>
.cards-pile {
    
}
.show {
    box-shadow: 0px 0px 10px 1px lime;
}
.pile-marker {
    position: absolute; 
    height: 100%; 
    width: 100%;
    background-size: 100% 100%;
    opacity: 0.4;
    transform: scale(1.2, 1.1);
}
.pile-counter {
    position: absolute; 
    z-index: 10000; 
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 2.5vw;
    pointer-events: none;
    text-shadow: 0px 0px 10px black;
    
}
.pile-actions {
    position: absolute; 
    z-index: 10000; 
    bottom: 0px; 
    display: flex;
    width: 100%;
}
.pile-actions button {
    width: 100%;
}
.btn-action {
    border: none;
    padding: 0px;
    margin: 0px;
    font-size: 1.2vw;
    background-color: rgba(0,0,0,0.5);
    color: white;
}
.pile-shake {
    animation: tilt-n-move-shaking 0.3s ease-in-out 0s 3;
}
@keyframes tilt-n-move-shaking {
    0% { transform: translateX(0) }
    25% { transform: translateX(5px) }
    50% { transform: translateX(-5px) }
    75% { transform: translateX(5px) }
    100% { transform: translateX(0) }
}

.pile-counter-drag {
    position: absolute; 
    z-index: 10000; 
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 3vw;
    pointer-events: none;
    background: rgba(0,0,0,0.7);
    transform: translate(-50%, -50%) scale(0.8);
    border-radius: 20px;
}

</style>